<template>
  <div>
       <!-- =============================================================================== -->

       <v-row justify="center">
          <v-dialog v-model="dialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Informações Pessoais</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <span>Nome completo: <v-chip color="primary">{{($store.state.objAluno === undefined)?'':$store.state.objAluno.nome}}</v-chip> </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span>Número de matricula:    <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.idMAtricula}}</strong>  </span>
                    </v-col>
                     <v-col cols="12" sm="6" md="6">
                      <span>Nº Bilhete: <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.bi}}</strong> </span>
                    </v-col>
                     <v-col cols="12" sm="6" md="6">
                      <span>Curso :  <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.curso}}</strong> </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span>Classe : <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.classe}}</strong> </span>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                         <v-card-title>
                            <span class="headline">Outras Informações</span>
                        </v-card-title>
                    </v-col>

                    <v-col cols="12" sm="4">
                    <v-text-field
                    append-icon="person"
                    label="Endereçamento do Documento"
                    type="text"
                    v-model="enderecamento"
                    :rules="[rules.required]"/>
                    </v-col>
                    <v-col cols="12" sm="4">
                    <v-text-field
                    label="Insira o nº ofício"
                    type="text"
                    v-model="numerooficio"
                    :rules="[rules.required]"/>
                    </v-col>
                    <v-col cols="12" sm="4">
                       <v-select
                        v-model="modelo"
                        item-value="id"
                        item-text="descricao"
                        :items="modelosImpressao"
                        label="Modelo de Impressão"
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="fecharComponente()">Cancelar</v-btn>
                 <v-btn :disabled="isHabilitado" color="blue darken-1" text @click="impressaoDocumento()">Vizualizar</v-btn>
               </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

<!--================================================================================== -->

  </div>
  </template>
<script>
import axios from '../../../plugins/axios'
import impressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    enderecamento: '',
    numerooficio: '',
    modelosImpressao: [{ id: 1, descricao: 'IMS' }, { id: 2, descricao: 'Local' }],
    modelo: { id: 2, descricao: 'Local' },
    dialog: true,
    rules: {
      required: value => !!value || 'Campo obrigatório.'
    },
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: 'O ofício de confirmação de vaga',
    configuracoesReport: ls.get('configuracoesReport')
  }),
  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    },
    isModeloIMS () {
      return this.modelo.id === 2 ? ls.get('i_id') : 1
    },
    isHabilitado () {
      return !(this.modelo && this.enderecamento.length && this.numerooficio.length)
    }
  },
  created  () { },
  methods: {

    formatarDataParaDescricao (data) {
      const d = new Date(data)
      const meses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      const dia = d.getDate()
      const mes = meses[d.getMonth()]
      const ano = d.getFullYear()

      return `${dia} de ${mes} de ${ano}`
    },

    descricaoEscola () {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.$store.state.objAluno.idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    getlogotipo () {
      let logotipoInstituto = ls.get('configuracoesReport').filter(c => c.chave === 'logotipo2')
      return (ls.get('isintegrado') === 0) ? ls.get('insignia') : (this.$store.state.objAluno.idCurso <= 24 ? ls.get('logotipo') : (logotipoInstituto[0].valor))
    },
    async impressaoDocumento () {
      const dataAtual = new Date()
      const data = this.formatarDataParaDescricao(dataAtual)
      let declaracaoConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'Declaração')
      let template = ''
      let dados = {
        '{{nome}}': this.$store.state.objAluno.nome,
        '{{pai}}': this.$store.state.objAluno.nomedopai,
        '{{mae}}': this.$store.state.objAluno.nomedamae,
        '{{municipio}}': this.$store.state.objAluno.municipio,
        '{{provincia}}': this.$store.state.objAluno.provincia,
        '{{numeroBi}}': this.$store.state.objAluno.bi,
        '{{emissaoBi}}': ((this.$store.state.objAluno.dataemissaobi).substring(0, 10)),
        '{{classe}}': this.$store.state.objAluno.classe,
        '{{curso}}': this.$store.state.objAluno.curso,
        '{{anoLectivo}}': this.$store.state.objAluno.novadescricao,
        '{{dataActual}}': data,
        '{{numerooficio}}': this.numerooficio,
        '{{enderecamento}}': this.enderecamento,
        '{{logotipo}}': this.getlogotipo(),
        '{{institutoDescricao}}': this.descricaoEscola(),
        '{{instituicao}}': this.descricaoEscola(),
        '{{dataNascimento}}': this.$store.state.objAluno.datanascimento,
        '{{dataNascimentoCompreensao}}': this.formatarDataParaDescricao((this.$store.state.objAluno.datanascimento).substring(0, 10)),
        '{{siglaEFTSL}}': (this.$store.state.objAluno.idCurso <= 24 ? declaracaoConfiguracoes[1].valor : ''),
        '{{assinante01}}': (declaracaoConfiguracoes[2].valor),
        '{{assinante02}}': (declaracaoConfiguracoes[3].valor)
      }

      try {
        template = await axios.get('/obterRelatorioByDescricao/ocv').then((res) => res.data)
        template = template.filter(r => r.idinstituicao == this.isModeloIMS)
        if (!template.length) {
          Swal.fire({ icon: 'info', title: '', text: 'Declaração sem nota, não configurada!' })
        } else {
          const expressaoRegular = new RegExp(Object.keys(dados).join('|'), 'g')
          template = template[0].documento.replace(expressaoRegular, (match) => dados[match])

          this.html = template

          try {
            this.$store.state.isloading = true
            let option = {
              'format': 'A4',
              'border': { 'top': '20cm', 'bottom': '20cm', 'left': '25cm' },
              'header': { 'height': '5mm' },
              'footer': { 'height': '5mm' }
            }

            impressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
          } catch (error) {
            this.fecharComponente()
          } finally {
            this.fecharComponente()
          }
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro durante a impressão do boletim!' })
      }
    },

    dia () {
      let day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    converterDataExtensao (valor) {
      let data = new Date(valor)
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    },
    fecharComponente () {
      this.$store.state.isloading = false
      this.dialog = false
      this.$emit('fecharComponente', false)
    }
  }
}

</script>
